<script setup lang="ts">
interface DropdownItemProps {
  // Optional — a dropdown used as an action menu (aria-role "menu") has no
  // selectable value, only a @click handler per item.
  value?: unknown;
  disabled?: boolean;
  ariaRole?: "listitem" | "menuitem";
}
const {
  value,
  disabled = false,
  ariaRole = "listitem"
} = defineProps<DropdownItemProps>();
</script>
<template>
  <b-dropdown-item :aria-role="ariaRole" :value="value" :disabled="disabled">
    <slot />
  </b-dropdown-item>
</template>
